import { useModel, useRequest } from "@umijs/max";
import React, {useState, useEffect} from 'react';
import { getSmartPushSchemeDetails } from '@/services/global';
import {planDetailsState, codeEditorState} from "@/states/planpage";
import {useProgramme} from '@/hooks/useProgramme'
// import marketingCalendarApi from './marketingCalendar'
import {
  http_essayExpand,
    getHotspotSchemeImage,
    http_updateScheme,
    http_essayPolish,
    http_SEOOptimization,
    http_dataGenerateAnalysisResults,
    http_hotspotGenerateAnalysisResults,
    http_updateRecordList,
    http_operateRestores,
    http_add_scheme_to_user
  } from '@/services/PublicApi';
import { message } from "antd";

let timerRef: any = null;
let timeTotal: number = 0;
const publicApi = () => {
    const controller = new AbortController();

    const { handle_fromObj } = useProgramme();
    // 请求图
    const { loading: hotspotSchemeImageLoading, data: hotspotSchemeImageData, run: handleHotspotSchemeImage, cancel: handleHotspotSchemeImageCancel} =
        useRequest(async (data) => {
            const result = await getHotspotSchemeImage(data);
            let hotspotSchemeImageData: any = [];
            if (result.status === 0) {
              hotspotSchemeImageData = result.payload
            } else {
              hotspotSchemeImageData = []
            }


            let a = hotspotSchemeImageData.filter((el: any) => {
              let a = el.hotspotSchemeImageInfoList.length;
              return a === 0;
            });
            if (timeTotal > 9 || hotspotSchemeImageData.length > 0) {
              clearInterval(timerRef);
              timerRef = null;
            } else if (timeTotal > 9 && hotspotSchemeImageData.length === 0) {
              clearInterval(timerRef);
              timerRef = null;
            } else {
              timerRef = setInterval(() => {
                handleHotspotSchemeImage(data);
                timeTotal += 1;
                clearInterval(timerRef);
              }, 3000);
            }
            
            return hotspotSchemeImageData
        }, {
        manual: true,
    });

    // 文案扩写
    const { loading: essayExpandLoading, data: essayExpandData, run: handleEssayExpand, cancel: handleEssayExpandCancel} =
        useRequest(async (data) => {
            const result = await http_essayExpand(data);
            let str: string = '';
            if (result.status === 0) {
              str = result.payload;
            } else {
                str = ''
            }
            return str
        }, {
        manual: true,
    });
    
    // 修改保存历史记录
    const { loading: updateSchemeLoading, data: updateSchemeData, run: handleUpdateScheme, cancel: handleUpdateSchemeCancel} =
        useRequest(async (data) => {
            const result = await http_updateScheme(data);
            let str: string = '';
            if (result.status === 0) {
            } else {
            }
            return str
        }, {
        manual: true,
    });

    // 文案润色
    const { loading: essayPolishLoading, data: essayPolishData, run: handleEssayPolish, cancel: handleEssayPolishCancel} =
        useRequest(async (data) => {
            const result = await http_essayPolish(data);
            let str: string = '';
            if (result.status === 0) {
              str = result.payload;
            } else {
                str = ''
            }
            return str
        }, {
        manual: true,
    });
    
    // 一键SEO优化
    const { loading: seoOptimizationLoading, data: seoOptimizationData, run: handleSEOOptimization, cancel: handleSEOOptimizationCancel} =
        useRequest(async (data) => {
            const result = await http_SEOOptimization(data);
            let str: string = '';
            if (result.status === 0) {
              str = result.payload;
              codeEditorState.seoOptimizationText = result.payload;
            } else {
              str = ''
              codeEditorState.seoOptimizationText = '';
            }
            return str
        }, {
        manual: true,
    });
    
    // 日历分析结果
    const { loading: dataGenerateAnalysisResultsLoading, data: dataGenerateAnalysisResultsData, run: handleDataGenerateAnalysisResults} =
        useRequest(async (data) => {
            planDetailsState.analysisLoading = false;
            planDetailsState.loading = false;
            planDetailsState.calendarAnalysis = {
              advice: '',
              matching_degree: '',
              risk: '',
              relevance: '',
            };
            return false
            const result = await http_dataGenerateAnalysisResults(data, controller.signal);
            planDetailsState.analysisLoading = false;
            planDetailsState.loading = false;
            if (result.status === 0) {
              planDetailsState.calendarAnalysis = result.payload;
            } else {
              planDetailsState.calendarAnalysis = {
                advice: '',
                matching_degree: '',
                risk: '',
                relevance: '',
              }
            }
            return result.payload
        }, {
        manual: true,
    });

    // 热点分析结果
    const { loading: hotspotGenerateAnalysisResultsLoading, data: hotspotGenerateAnalysisResultsData, run: handleHotspotGenerateAnalysisResults} =
        useRequest(async (data) => {
          planDetailsState.analysisLoading = false;
            planDetailsState.loading = false;
            planDetailsState.calendarAnalysis = {
              advice: '',
              matching_degree: '',
              risk: '',
              relevance: '',
            };
            return false
            const result = await http_hotspotGenerateAnalysisResults(data, controller.signal);
            planDetailsState.analysisLoading = false;
            planDetailsState.loading = false;
            if (result.status === 0) {
              planDetailsState.calendarAnalysis = result.payload;
            } else {
              planDetailsState.calendarAnalysis = {
                advice: '',
                matching_degree: '',
                risk: '',
                relevance: '',
              }
            }
            return result.payload
        }, {
        manual: true,
    });
    const handleControllerCancel = () => {
      controller.abort();
    }
     
    // 历史记录
    const { loading: updateRecordListLoading, data: updateRecordListData, run: handleUpdateRecordList, cancel: handleUpdateRecordListCancel} =
        useRequest(async (data) => {
            const result = await http_updateRecordList(data);
            let arr: any = [];
            if (result.status === 0) {
              arr = result.payload;
              planDetailsState.historicalRecordsList = result.payload
            } else {
              arr = []
              planDetailsState.historicalRecordsList = []
            }
            return arr
        }, {
        manual: true,
    });

      
    // 还原历史记录
    const { loading: operateRestoresLoading, data: operateRestoresData, run: handleOperateRestorest, cancel: handleOperateRestorestCancel} =
        useRequest(async (data) => {
            const result = await http_operateRestores(data);
            let arr: any = [];
            if (result.status === 0) {
              let schemeContent = result.payload.schemeContent ? JSON.parse(result.payload.schemeContent) : {};
              if(result.payload.channelName == "直播文案" && schemeContent.text_title) {
                schemeContent = {
                  poster: [
                    {
                      poster_main_title: schemeContent.text_title,
                      poster_subtitle: schemeContent.text_title,
                    }
                  ],
                  poster_brief: schemeContent.text_content,
                  socialmedia: "直播文案",
                  socialmedia_text: schemeContent.text_content,
                  socialmedia_text_title: schemeContent.text_title,
                }
              }
              planDetailsState.creativeProposalList = planDetailsState.creativeProposalList.map((item: any, index: number) => {
                if (index === planDetailsState.activeIndex) {
                  for(let key in schemeContent) {
                    item[key] = schemeContent[key];
                  }
                  if (!schemeContent.data) {
                    item.data = handle_fromObj(schemeContent, item.data[0])
                  }
                  Object.assign(item, {
                    socialmedia: result.payload.channelName,
                    hotspotSchemeImageInfoList: result.payload.hotspotSchemeImageInfoList || [],
                  });
                }
                return item;
              });
              planDetailsState.activeFrom = planDetailsState.creativeProposalList[planDetailsState.activeIndex];
              planDetailsState.isHistoricalRecords = true;
            } else {
              planDetailsState.activeFrom = planDetailsState.creativeProposalList[planDetailsState.activeIndex];
              planDetailsState.isHistoricalRecords = true;
            }
            
            return result.payload
        }, {
        manual: true,
    });

    // 加入方案
    const { loading: schemeToUserLoading, data: schemeToUserData, run: handleSchemeToUser, cancel: handleSchemeToUserCancel} =
        useRequest(async (data) => {
            const result = await http_add_scheme_to_user(data);
            let arr: any = [];
            if (result.status === 0) {
              arr = result.payload;
            } else {
              arr = []
            }
            return arr
        }, {
        manual: true,
    });

    
    let schemeDetailsClare: any = null;
    const { loading: schemeDetailsLoading, data: schemeDetailsData, run: handleSchemeDetails, cancel: handleSchemeDetailsCancel, reset} = 
      useRequest(async (data) => {
        const result: any = await getSmartPushSchemeDetails(data);
        let o: any = {}
        if (result.status == 0) {
          let channelIds: any = [];
          let arr = result.payload.schemeLists.map((item:any) => {
            channelIds.push(item.id);
            let obj = JSON.parse(item.schemeContent);
            return {
                ...obj,
                ...item,
                hotspotSchemeImageInfoList: Array.isArray(item.schemeLists)? item.schemeLists.filter((i:any) => i.isDelete == 0) : item.schemeLists
            }
          });
          let inspiration = result.payload.assistantCurrent?  result.payload.assistantCurrent.topicName : result.payload.marketingCalendar.festivalName
          let dataId = result.payload.assistantCurrent?  result.payload.assistantCurrent.id : result.payload.marketingCalendar.festivalId
          let marketingCalendarState: any = JSON.parse(localStorage.getItem('marketingCalendar'));
          o = {
              schemeAnalysisInfo: {
                  ...result.payload.schemeAnalysisInfo,
                  inspiration: inspiration,
              },
              hotspotAnalysis: result.payload.schemeAnalysisInfo? JSON.parse(result.payload.schemeAnalysisInfo.hotspotAnalysis) : [],
              productsName: result.payload.productsName,
              inspiration: inspiration,
              serviceRequest: result.payload.serviceRequest,
              brandName: result.payload.brandName,
              brandId: result.payload.brandId,
              productsId: result.payload.productsId,
              schemeLists: arr,
              assistantId: marketingCalendarState.assistantId,
              id: result.payload.id,
              parameterId: result.payload.id,
              schemeState: result.payload.schemeState,
              hotspotDetail: result.payload.assistantCurrent && result.payload.assistantCurrent.hotspotBrief? result.payload.assistantCurrent.hotspotBrief : '',
          }
          if (result.payload.assistantCurrent) {
            o['hotspotId'] = dataId;
          } else {
            o['dataId'] = dataId;
          }
          // 方案生成成功后 请求对应图片
          if (channelIds.length > 0) {
            handleHotProgrammeImages({ channelId: channelIds.join(',') });
          }
          if (result.payload.schemeState == 2 && result.payload.schemeLists.length === 0) {
            schemeDetailsClare = setTimeout(() => {
              clearTimeout(schemeDetailsClare);
              handleSchemeDetails(data);
            }, 5000)
          } else {
            
          }
        } else {
          o = null;
          planDetailsState.informationLoading = false;
        }
        
        return o;
    }, {
    manual: true,
  });

  const controllerHotProgrammeImages = new AbortController();
  let clareImage: any = null;
  // 请求图 af 生成方案后请求对应方案的图片
  const { loading: hotProgrammeImagesLoading, data: hotProgrammeImagesData, run: handleHotProgrammeImages} =
      useRequest(async (data:  any) => {
          const result = await getHotspotSchemeImage(data, controllerHotProgrammeImages.signal);
          let total = 1;
          if (result.payload && result.payload.length > 0) {
              planDetailsState.programmeTotal = 1;
              handle_schemeDetailsCancel();
              planDetailsState.creativeProposalList = planDetailsState.creativeProposalList.map((item: any) => {
                  let flag = result.payload.find((i: any) => i.id === item.id);
                  if (flag) {
                      Object.assign(item, {
                          hotspotSchemeImageInfoList: flag.hotspotSchemeImageInfoList
                      });
                  }
                  return item;
              });
              if (planDetailsState.creativeProposalList.length > 0) {
                planDetailsState.activeFrom = planDetailsState.creativeProposalList[0];
              }
          } else {
            if (planDetailsState.programmeTotal <= 9 && (location.pathname.includes('planDetails') || location.pathname.includes('planPageInfo'))) {
              planDetailsState.programmeTotal = planDetailsState.programmeTotal + 1;
              clareImage = setTimeout(() => {
                clearTimeout(clareImage);
                handleHotProgrammeImages(data);
              }, 3000)
            } else {
              planDetailsState.programmeTotal = 1;
              handle_schemeDetailsCancel();
            }
          }
          
          return result
      }, {
      manual: true,
      pollingWhenHidden: false,
  });

  const handle_schemeDetailsCancel = () => {
    reset()
    handleSchemeDetailsCancel();
    clearTimeout(schemeDetailsClare);
    clearTimeout(clareImage);
    controllerHotProgrammeImages.abort();
  }

  return {
    hotspotSchemeImageLoading,
    hotspotSchemeImageData,
    handleHotspotSchemeImage,
    essayExpandLoading,
    essayExpandData,
    handleEssayExpand,
    updateSchemeLoading,
    updateSchemeData,
    handleUpdateScheme,
    essayPolishLoading,
    essayPolishData,
    handleEssayPolish,
    seoOptimizationLoading,
    seoOptimizationData,
    handleSEOOptimization,
    dataGenerateAnalysisResultsLoading,
    dataGenerateAnalysisResultsData,
    handleDataGenerateAnalysisResults,
    handleControllerCancel,
    updateRecordListLoading,
    updateRecordListData,
    handleUpdateRecordList,
    handleHotspotGenerateAnalysisResults,
    hotspotGenerateAnalysisResultsData,
    hotspotGenerateAnalysisResultsLoading,
    handleOperateRestorest,
    operateRestoresData,
    operateRestoresLoading,
    schemeToUserLoading, schemeToUserData,
    handleSchemeToUser,
    schemeDetailsData,
    handleSchemeDetails,
    handle_schemeDetailsCancel,
  }
};

export default publicApi;
